export const plural = (count: number, rules: [string, string, string]) => {
  const result = new Intl.PluralRules("en-US").select(count);
  if (result === "one") return rules[0];
  if (result === "two") return rules[1];
  return rules[2];
};
